// extracted by mini-css-extract-plugin
export default {"image":"Photo_image__n3qLf"};